import { AptunoButton, SIZES, useResponsive, VARIANTS } from '@aptuno/aptuno-ui';
import { useRouter } from 'next/router';
import React from 'react';
import { ActionsBarRoot, BigTitle, HeaderSection, ImageWrapper, TitleDescription } from '../EstateApplication.styled';
import { LeaveWrapper } from './LeaveApplicationScreen.styled';

type Props = {
  isIsolatedPage?: boolean;
  onLeave?: () => void;
  onCancelLeave?: () => void;
};

export const LeaveApplicationScreen = ({ isIsolatedPage = false, onLeave, onCancelLeave }: Props) => {
  const router = useRouter();

  const { isMobile } = useResponsive();

  const handleOnClickLeaveBtn = () => {
    if (onLeave) {
      onLeave();
    } else {
      router.push('/perfil');
    }
  };
  const handleOnClickBackBtn = () => {
    if (onCancelLeave) {
      onCancelLeave();
    } else {
      router.back();
    }
  };

  const LeaveText = isMobile
    ? 'Guardaremos la información que has ingresado hasta el momento. ¿Quieres salir?'
    : 'Guardaremos la información que has ingresado hasta el momento. Puedes retomar tu aplicación cuando desees ¿Quieres salir?';

  return (
    <>
      <LeaveWrapper isMobile={isMobile}>
        <HeaderSection horizontalAlign="center" padding={'0 0 34px 0'}>
          <ImageWrapper height={`210px`} width={`248px`} margin={isMobile ? '48px 0 4px 0' : '64px 0 14px 0'}>
            <img src={`/images/abandonar.svg`} alt="Application in progress" />
          </ImageWrapper>
          <BigTitle margin="28px 0 16px 0">Vas a abandonar tu aplicación.</BigTitle>
          <TitleDescription>{LeaveText}</TitleDescription>
        </HeaderSection>
      </LeaveWrapper>
      <ActionsBarRoot
        flexDirection={isMobile ? 'column' : 'row-reverse'}
        bgColor={'transparent'}
        border={'none'}
        height={'auto'}
        margin={'0'}
      >
        <AptunoButton appearance={VARIANTS.PRIMARY} size={SIZES.BIGGEST} onClick={handleOnClickLeaveBtn}>
          Sí, abandonar
        </AptunoButton>
        <AptunoButton appearance={VARIANTS.SECONDARY} size={SIZES.BIGGEST} onClick={handleOnClickBackBtn}>
          No, volver a la aplicación
        </AptunoButton>
      </ActionsBarRoot>
    </>
  );
};
